package de.ohhhmhhh.frontend.admin.ui.components.other

import androidx.compose.runtime.Composable
import kotlin.enums.enumEntries

private const val ALL = "Alle"

@Composable
fun <T> SimpleSelect(
    adapter: SelectAdapter<T>,
    selected: T? = null,
    withAll: Boolean = true,
    onSelect: (T?) -> Unit
) {
    val prefix = if (withAll) listOf(ALL) else emptyList()
    val mapped = adapter.allItems().map { adapter.label(it) }

    SimpleSelect(
        items = prefix + mapped,
        selected = selected?.let(adapter::label),
        onSelect = {
            it.takeIf { v -> !withAll || v != ALL }
                ?.let { v -> adapter.fromLabel(v) }
                .let(onSelect)
        }
    )
}

inline fun <reified T : Enum<T>> EnumSelectAdapter(crossinline mapper: (T) -> String = { it.name }) =
    object : SelectAdapter<T>() {
        override fun allItems(): List<T> = enumEntries()
        override fun label(item: T): String = mapper(item)
    }


abstract class SelectAdapter<T> {

    abstract fun allItems(): List<T>

    abstract fun label(item: T): String

    fun fromLabel(label: String): T? = allItems().firstOrNull { label(it) == label }

}